import React from 'react';
import { SubmitHandler, useForm, Controller } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import ActionButton from '../atoms/ActionButton';
import DatePicker from '../atoms/DatePicker';

const formSchema = z.object({
  toName: z
    .string()
    .min(1, '相手の名前を入力してください')
    .max(15, '15文字以内で入力してください'),
  fromName: z
    .string()
    .min(1, 'あなたの名前を入力してください')
    .max(15, '15文字以内で入力してください'),
  date: z.string().min(1, '日付を選択してください'),
  endDate: z.string(),
});

export type FormData = z.infer<typeof formSchema>;

interface QuestionFormProps {
  defaultValues?: FormData;
  onSubmit?: SubmitHandler<FormData>;
}

const QuestionForm: React.FC<QuestionFormProps> = ({
  defaultValues,
  onSubmit = () => {},
}) => {
  const {
    register,
    handleSubmit,
    watch,
    getValues,
    control,
    formState: { errors },
  } = useForm<FormData>({
    resolver: zodResolver(formSchema),
    defaultValues,
  });

  return (
    <div className='p-form-box -question'>
      <form onSubmit={handleSubmit(onSubmit)} className='p-form -question'>
        <dl className='p-form__item'>
          <dt>
            <label htmlFor='to' className='p-form__label'>
              相手の名前
            </label>
          </dt>
          <dd>
            <input
              type='text'
              className='p-form__input'
              placeholder='15文字以内'
              {...register('toName')}
            />
            {errors.toName && (
              <p className='c-txt-error'>{errors.toName.message}</p>
            )}
          </dd>
        </dl>
        <dl className='p-form__item'>
          <dt>
            <label htmlFor='from' className='p-form__label'>
              あなたの名前
            </label>
          </dt>
          <dd>
            <input
              type='text'
              className='p-form__input'
              placeholder='15文字以内'
              {...register('fromName')}
            />
            {errors.fromName && (
              <p className='c-txt-error'>{errors.fromName.message}</p>
            )}
          </dd>
        </dl>
        <dl className='p-form__item'>
          <dt>
            <label htmlFor='date' className='p-form__label'>
              日付
            </label>
          </dt>
          <dd>
            <Controller
              name='date'
              control={control}
              render={({ field }) => (
                <DatePicker
                  {...field}
                  onDateChange={(date: string) => field.onChange(date)}
                />
              )}
            />
            {errors.date && (
              <p className='c-txt-error'>{errors.date.message}</p>
            )}
          </dd>
        </dl>
        <dl className='p-form__item'>
          <dt>
            <label htmlFor='date' className='p-form__label'>
              表示期限
            </label>
          </dt>
          <dd>
            <Controller
              name='endDate'
              control={control}
              render={({ field }) => (
                <DatePicker
                  {...field}
                  minDate={new Date(Date.now() - 24 * 60 * 60 * 1000)}
                  onDateChange={(date: string) => field.onChange(date)}
                />
              )}
            />
            {errors.endDate && (
              <p className='c-txt-error'>{errors.endDate.message}</p>
            )}
          </dd>
        </dl>

        <div className='u-mt60'>
          <ActionButton type='submit'>次へ</ActionButton>
        </div>
      </form>
    </div>
  );
};

export default QuestionForm;
